import { Col } from 'antd'

import { EpidemiologyCaseForm058E_SymptomsSection } from 'src/api/requests'
import { Text } from 'src/components'
import { useLocales } from 'src/locales'

type Props = {
  symptoms: EpidemiologyCaseForm058E_SymptomsSection
}

export const RespiratorySymptomsDetailsCard = ({ symptoms }: Props) => {
  const { t } = useLocales()

  const coughLabel = t('epidemiology.symptoms.respiratory.cough')
  const tonsillitisLabel = t('epidemiology.symptoms.respiratory.tonsillitis')

  return (
    <>
      <Col span={24}>
        <Text>
          {`5. ${t('epidemiology.respiratory')}`}:{' '}
          <Text weight={400}>
            {t(`epidemiology.symptoms.general.${symptoms.respiratory?.status}`)}
          </Text>
        </Text>
      </Col>

      {symptoms.respiratory?.status === 'yes' && (
        <>
          {symptoms.respiratory?.rhinitis?.isSelected && (
            <Col span={8}>
              <Text>{t('epidemiology.symptoms.respiratory.rhinitis')}</Text>
            </Col>
          )}

          {symptoms.respiratory?.nasalHemorrhage?.isSelected && (
            <Col span={8}>
              <Text>
                {t('epidemiology.symptoms.respiratory.nasalHemorrhage')}
              </Text>
            </Col>
          )}

          {symptoms.respiratory?.pharyngitisLaryngitis?.isSelected && (
            <Col span={8}>
              <Text>
                {t('epidemiology.symptoms.respiratory.pharyngitisLaryngitis')}
              </Text>
            </Col>
          )}

          {symptoms.respiratory?.aerophobia?.isSelected && (
            <Col span={8}>
              <Text>{t('epidemiology.symptoms.respiratory.aerophobia')}</Text>
            </Col>
          )}

          {symptoms.respiratory?.cough?.isSelected && (
            <>
              <Col span={8}>
                <Text>{coughLabel}</Text>
              </Col>

              {symptoms.respiratory?.cough.oneToTwoWeeks?.isSelected && (
                <Col span={8}>
                  <Text>
                    {coughLabel} -{' '}
                    {t('epidemiology.symptoms.respiratory.oneToTwoWeeks')}
                  </Text>
                </Col>
              )}

              {symptoms.respiratory?.cough.moreThanTwoWeeks?.isSelected && (
                <Col span={8}>
                  <Text>
                    {coughLabel} -{' '}
                    {t('epidemiology.symptoms.respiratory.moreThanTwoWeeks')}
                  </Text>
                </Col>
              )}

              {symptoms.respiratory?.cough.paroxysmal?.isSelected && (
                <Col span={8}>
                  <Text>
                    {coughLabel} -{' '}
                    {t('epidemiology.symptoms.respiratory.paroxysmal')}
                  </Text>
                </Col>
              )}

              {symptoms.respiratory?.cough.mucopurulent?.isSelected && (
                <Col span={8}>
                  <Text>
                    {coughLabel} -{' '}
                    {t('epidemiology.symptoms.respiratory.mucopurulent')}
                  </Text>
                </Col>
              )}

              {symptoms.respiratory?.cough.bloodySputum?.isSelected && (
                <Col span={8}>
                  <Text>
                    {coughLabel} -{' '}
                    {t('epidemiology.symptoms.respiratory.bloodySputum')}
                  </Text>
                </Col>
              )}
            </>
          )}

          {symptoms.respiratory?.tonsillitis?.isSelected && (
            <>
              <Col span={8}>
                <Text>{tonsillitisLabel}</Text>
              </Col>

              {symptoms.respiratory.tonsillitis.membranous?.isSelected && (
                <Col span={8}>
                  <Text>
                    {tonsillitisLabel} -{' '}
                    {t('epidemiology.symptoms.respiratory.membranous')}
                  </Text>
                </Col>
              )}

              {symptoms.respiratory.tonsillitis.cataral?.isSelected && (
                <Col span={8}>
                  <Text>
                    {tonsillitisLabel} -{' '}
                    {t('epidemiology.symptoms.respiratory.cataral')}
                  </Text>
                </Col>
              )}

              {symptoms.respiratory.tonsillitis.purulent?.isSelected && (
                <Col span={8}>
                  <Text>
                    {tonsillitisLabel} -{' '}
                    {t('epidemiology.symptoms.respiratory.purulent')}
                  </Text>
                </Col>
              )}

              {symptoms.respiratory.tonsillitis.necrotic?.isSelected && (
                <Col span={8}>
                  <Text>
                    {tonsillitisLabel} -{' '}
                    {t('epidemiology.symptoms.respiratory.necrotic')}
                  </Text>
                </Col>
              )}
            </>
          )}
        </>
      )}
    </>
  )
}
